import React from 'react';

function InstagramTab({ project, categoryTab }) {

  return (
    <div>
      <h3 className="text-lg font-semibold mb-2">
        Instagram - {project} - {categoryTab}
      </h3>
      <p className="text-gray-700 mb-2">
        Placeholder content for Instagram.
      </p>
      {/* Add Instagram specific content here based on the selected category tab */}
    </div>
  );
}

export default InstagramTab;